
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import {} from "vue-router";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import enUS from "ant-design-vue/es/locale/en_US";
import ruRU from "ant-design-vue/es/locale/ru_RU";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "App",
  props: {},
  emits: [],
  setup() {
    const localeType = ref(zhCN);
    const store = useStore();
    const maxHeight = window.innerHeight - 300;
    store.commit("setMaxHeight", maxHeight);

    const { locale } = useI18n();
    const languageType = computed(() => store.getters.getLocalLanguage);

    watch(languageType, () => {
      if (languageType.value === zhCN.locale) {
        localeType.value = zhCN;
        dayjs.locale(zhCN.locale);
      }
      if (languageType.value === enUS.locale) {
        localeType.value = enUS;
        dayjs.locale(enUS.locale);
      }
      if (languageType.value === ruRU.locale) {
        localeType.value = ruRU;
        dayjs.locale(ruRU.locale);
      }
    });

    onMounted(() => {
      if (localStorage.getItem("wxbLan")) {
        const lanType = JSON.parse(localStorage.getItem("wxbLan") as any);
        locale.value = lanType;
        if (lanType === zhCN.locale) {
          localeType.value = zhCN;
        }
        if (lanType === enUS.locale) {
          localeType.value = enUS;
        }
        if (lanType === ruRU.locale) {
          localeType.value = ruRU;
        }
        store.commit("setLocalLanguage", lanType);
      }
    });

    return {
      localeType,
    };
  },
});
